angular.module('zc.zenclerkS')

  .controller('ZcsPreviewLinkModalController', ZcsPreviewLinkModalController);


ZcsPreviewLinkModalController.$inject = ['$uibModalInstance', 'Campaign', 'campaign', 'project'];
function ZcsPreviewLinkModalController($uibModalInstance, Campaign, campaign, project) {
  const vm = this;
  vm.campaign = campaign;
  vm.project = project;
  vm.previewUrl = Campaign.previewUrl(vm.project.base_url, vm.campaign);

  vm.close = () => {
    $uibModalInstance.close();
  };
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/campaigns/preview_link_modal.controller.js